import { render, staticRenderFns } from "./DiamondClubPage.vue?vue&type=template&id=581fe12a&"
import script from "./DiamondClubPage.vue?vue&type=script&lang=js&"
export * from "./DiamondClubPage.vue?vue&type=script&lang=js&"
import style0 from "./DiamondClubPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
